import { render, staticRenderFns } from "./PlusAccountModal.vue?vue&type=template&id=2dc26250&"
import script from "./PlusAccountModal.vue?vue&type=script&lang=js&"
export * from "./PlusAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports